module.exports = __webpack_public_path__ + "media/jegesmedve_k.94a810c7.mp3";